<template>
    <kgr-modal
        headline="Standard-SEPA-Lastschrift zuweisen"
        :value="show"
    >
        <kgr-loading v-show="loading" />
        <div v-show="!loading">
            <h3
                v-if="assigning || assigned"
                class="kgr-headline kgr-headline--h3"
            >
                Hinterlegung des Standardkontos bei den Beiträgen ab {{ formatDate(memberSepaDebit.defaultStartingAt) }} mit folgendem Status.
            </h3>
            <h3
                v-else-if="filteredMemberClubFees.length > 0"
                class="kgr-headline kgr-headline--h3"
            >
                Möchtest du bei diesen Beiträgen das Standardkonto ab {{ formatDate(memberSepaDebit.defaultStartingAt) }} als neue Zahlungsart hinterlegen?
            </h3>
            <p v-else>
                Es gibt keine Gebühren, für die das Standardkonto ab {{ formatDate(memberSepaDebit.defaultStartingAt) }} als neue Zahlungsart hinterlegt werden kann.
            </p>
            <div
                v-for="mcf in filteredMemberClubFees"
                :key="mcf.id"
                class="kgr-definitionList"
            >
                <dt class="kgr-definitionList__term">
                    <kgr-icon
                        v-if="'loading' === status[mcf.id] "
                        icon-class="clock"
                    />
                    <kgr-icon
                        v-if="'error' === status[mcf.id] "
                        icon-class="warning"
                        style="color:red;"
                        :title="warningText()"
                    />
                    <kgr-icon
                        v-if="'success' === status[mcf.id] "
                        icon-class="check"
                        style="color:green;"
                    />
                    {{ mcf.clubFee }} ({{ mcf.member.name }})
                </dt>
                <dd class="kgr-definitionList__definition">
                    <template v-if="!mcf.discount || mcf.discount.type !== 'fixed_price'">
                        {{ getPricePerTime(mcf.pricePerTime) }}<br />
                    </template>
                    <template v-if="mcf.discount && mcf.discount.type === 'fixed_price'">
                        <span style="text-decoration: line-through">{{ getPricePerTime(mcf.pricePerTime) }}</span><br />
                        {{ getDiscountedPricePerTime(mcf.pricePerTime, mcf.discount.price) }}<br />
                    </template>
                    Vergünstigung:
                    <template v-if="mcf.discount && mcf.discount.type === 'percentage'">
                        {{ mcf.discount.name }}
                    </template>
                    <template v-if="mcf.discount && mcf.discount.type === 'fixed_price'">
                        individueller Preis
                    </template>
                    <template v-if="!mcf.discount">
                        nein
                    </template>
                    <br />

                    Aktuelle Zahlungsart: {{ formatPaymentMethod(mcf.paymentMethod) }}<br />
                    Laufzeit: {{ formatRunTime(mcf.runTime) }}
                </dd>
            </div>
        </div>
        <template #footer>
            <kgr-loading v-if="assigning" />
            <kgr-button
                v-else-if="assigned || filteredMemberClubFees.length === 0"
                value="OK"
                @click="assignClose()"
            />
            <template v-else>
                <kgr-button
                    value="Hinterlegen"
                    @click="assign()"
                />
                <kgr-button
                    value="Abbrechen"
                    type="grey"
                    @click="assignClose()"
                />
            </template>
        </template>
    </kgr-modal>
</template>

<script>
import ErrorHandler from '../../../js/accounting/ErrorHandler.js';
import GenericModal from '../../common/modal/GenericModal.vue'
import Helper from '../../../js/accounting/Helper.js';
import Icon from '../../common/icon/Icon.vue'
import KgrButton from '../../common/form/button/KgrButton.vue'
import Loading from '../../common/Loading.vue'
import Vue from 'vue';
import axios from 'axios';

export default {
    components: {
        'kgr-modal': GenericModal,
        'kgr-loading': Loading,
        'kgr-button': KgrButton,
        'kgr-icon': Icon,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        memberSepaDebit: {
            type: Object,
            required: true,
        },
        memberClubFees: {
            type: Array,
            required: true,
        },
        memberId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            assigned: false,
            assigning: false,
            filteredMemberClubFees: [],
            status: [],
        }
    },
    computed: {

    },
    watch: {
        memberClubFees() {
            this.initStatus();
            this.filteredMemberClubFees = this.filterMemberClubFees();
        }
    },
    created() {
        this.helper = new Helper();
        this.initStatus();
        this.filteredMemberClubFees = this.filterMemberClubFees();
    },
    methods: {
        formatDate(date) {
            return this.helper.formatDate(date);
        },
        getPricePerTime(pricePerTime) {

            return this.helper.getPricePerTime(pricePerTime);
        },
        getDiscountedPricePerTime(pricePerTime, discountedPrice) {

            return new Helper().getDiscountedPricePerTime(pricePerTime, discountedPrice);
        },
        formatPaymentMethod(paymentMethod) {
            return this.helper.translatePaymentMethod(paymentMethod);
        },
        formatRunTime(runTime) {
            let runTimeString = 'ab ' + this.helper.formatDate(runTime.start);

            if(runTime.end) {
                runTime = runTime + ' bis ' + this.helper.formatDate(runTime.end);
            }

            return runTimeString;
        },
        filterMemberClubFees() {
            return this.memberClubFees.filter(memberClubFee => !memberClubFee.archived);
        },
        assign() {
            const start = this.getApiDateFromString(this.memberSepaDebit.defaultStartingAt);
            if (start === null) {
                return;
            }

            this.assigning = true;
            var posts = this.filteredMemberClubFees.map(memberClubFee => {
                this.status[memberClubFee.id] = 'loading';
                return axios
                    .post('/club/member-club-fees/' + memberClubFee.id + '/payment-method-history-elements', {
                        start: start,
                        paymentMethod: {
                            type: 'sepa-debit',
                            id: this.memberSepaDebit.id
                        },
                    }, {
                        headers: new ErrorHandler().enableCustomErrorHandling({})
                    }).then(() => {
                        this.status[memberClubFee.id] = 'success';
                    }).catch(() => {
                        this.status[memberClubFee.id] = 'error';
                    })
            });
            axios.all(posts)
                .then(() => {
                    this.assigned = true;
                })
                .finally(() => {
                    this.assigning = false;
                })
            ;
            this.$emit('assigned');
        },
        getApiDateFromString(string) {
            if (typeof string !== 'string') {
                return null;
            }

            let [year, month, day] = string.split('-');

            return {
                'day': parseInt(day),
                'month': parseInt(month),
                'year': parseInt(year),
            }
        },
        initStatus() {
            this.status = [];
            this.memberClubFees.forEach(memberClubFee => {
                Vue.set(this.status, memberClubFee.id, 'open');
            })
        },
        warningText() {
            let formattedDate = this.formatDate(this.memberSepaDebit.defaultStartingAt);
            return 'Diese Gebühr konnte nicht mit dem Standardkonto verknüpft werden, weil am ' + formattedDate + ' bereits eine andere Zahlungsart startet.';
        },
        assignClose() {
            this.$emit('close', true);
        }
    }
}
</script>
